// styles imports
import './Chip.scss';

// メインのコンポーネント定義
export default function Chip(props) {
  return (
    <div className={"chip " + (props.className ? props.className : "")}>
      {props.children}
    </div>
  );
}
